import React from 'react';
import "./AboutUsStyles.css";

function AboutUs() {
  return (
    <div className='about-container'>

      <h1>Our History</h1>
      <p>
      Tripper was born out of a passion for travel and a desire to make trip planning easier for everyone. What started as a small project among friends who loved to explore the world quickly grew into a comprehensive platform designed to address the challenges that every traveler faces. 
      </p>

      <h1>Our Mission</h1>
      <p>
      At Tripper, our mission is to empower travelers to explore the world with confidence and ease. We believe that every journey should be a seamless and enriching experience, free from the stress of planning and logistics. 
      </p>

      <h1>Our Vision</h1>
      <p>
      Our vision at Tripper is to redefine the way people experience travel by creating a world where planning a trip is as enjoyable as the journey itself. We envision a future where travelers can effortlessly organize their adventures, confidently manage their itineraries and expenses, and focus entirely on the joy of discovery. 
      </p>

    </div>
  )
}

export default AboutUs
